import { render, staticRenderFns } from "./ReportCont.vue?vue&type=template&id=b7c0f70c&scoped=true"
import script from "./ReportCont.vue?vue&type=script&lang=js"
export * from "./ReportCont.vue?vue&type=script&lang=js"
import style0 from "./ReportCont.vue?vue&type=style&index=0&id=b7c0f70c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c0f70c",
  null
  
)

export default component.exports